import Vue from 'vue'
import moment from 'moment'
import momentTZ from 'moment-timezone'
import i18n from '@/lang/index'

export function numberWithCommas(value) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

Vue.filter('numberWithCommas', numberWithCommas)

Vue.filter('currencyIcon', function(currency) {
  switch (currency) {
    case 'USD':
      return require('@/assets/uploads/currencyIcon/USD_icon.png')
    case 'AUD':
      return require('@/assets/uploads/currencyIcon/AUD_icon.png')
    case 'CAD':
      return require('@/assets/uploads/currencyIcon/CAD_icon.png')
    case 'EUR':
      return require('@/assets/uploads/currencyIcon/EUR_icon.png')
    case 'GBP':
      return require('@/assets/uploads/currencyIcon/GBP_icon.png')
    case 'NZD':
      return require('@/assets/uploads/currencyIcon/NZD_icon.png')
    case 'SGD':
      return require('@/assets/uploads/currencyIcon/SGD_icon.png')
    case 'JPY':
      return require('@/assets/uploads/currencyIcon/JPY_icon.png')
    case 'HKD':
      return require('@/assets/uploads/currencyIcon/HKD_icon.png')
    case 'USC':
      return require('@/assets/uploads/currencyIcon/USC_icon.png')
    case 'PLN':
      return require('@/assets/uploads/currencyIcon/PLN_icon.png')
    case 'INR':
      return require('@/assets/uploads/currencyIcon/INR_icon.png')
    case 'BTC':
      return require('@/assets/uploads/currencyIcon/BTC_icon.png')
    case 'ETH':
      return require('@/assets/uploads/currencyIcon/ETH_icon.png')
    default:
      return require('@/assets/uploads/currencyIcon/default_icon.png')
  }
})

Vue.filter('currencySymbol', function(currency) {
  switch (currency) {
    case 'USD':
      return '$'
    case 'AUD':
      return 'A$'
    case 'CAD':
      return 'C$'
    case 'EUR':
      return '€'
    case 'GBP':
      return '￡'
    case 'NZD':
      return 'NZ$'
    case 'SGD':
      return 'S$'
    case 'JPY':
      return '￥'
    case 'USC':
      return '￠'
    case 'HKD':
      return 'HK$'
    default:
      return '$'
  }
})

Vue.filter('formatDate', function(value, format) {
  if (value) {
    return format ? moment(String(value)).format(format) : moment(String(value)).format('YYYY-MM-DD')
  }
})

Vue.filter('dateFormatWithTimeZone', function(dataStr, pattern = 'DD/MM/YYYY HH:mm:ss zz') {
  let timezone = momentTZ.tz.guess()
  let EDTTime = momentTZ.tz(dataStr, 'YYYY-MM-DD HH:mm zz', 'America/New_York')
  return EDTTime.clone()
    .tz(timezone)
    .format(pattern)
})

Vue.filter('formatTimestamp', function(value, format) {
  if (value) {
    return format ? moment.unix(String(value)).format(format) : moment.unix(String(value)).format('YYYY-MM-DD')
  }
})

Vue.filter('date', function(dataStr, pattern = 'DD/MM/YYYY') {
  return moment(dataStr).format(pattern)
})

Vue.filter('formatNumber', function(value, decimals) {
  if (value >= 0 && typeof value == 'number') {
    return decimals ? value.toFixed(decimals) : value.toFixed(2)
  }
})

Vue.filter('payStatus', status => {
  var key = status.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/\s]/g, '').toLowerCase()
  return i18n.t('transferHistory.payStatus.' + key)
})

Vue.filter('formatPlatform', function(value) {
  if (value == '4') {
    return 'MT4'
  }
  if (value == '5') {
    return 'MT5'
  }
})

Vue.filter('formatUppercase', function(value) {
  if (value) {
    return value.toUpperCase()
  }
})

Vue.filter('country', function(key) {
  var key = removeSpecialChars(key)
  return i18n.t('common.country.' + key)
})

function removeSpecialChars(key) {
  return key.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/\s]/g, '').toLowerCase()
}

Vue.filter('googleLangSwitch', lang => {
  switch (lang) {
    case 'en_US':
      return 'en'
    case 'zh_CN':
      return 'zh-CN'
    case 'zh_TW':
      return 'zh-TW'
    case 'fr_FR':
      return 'fr'
    case 'ja':
      return 'ja'
    case 'ko':
      return 'ko'
    case 'vi':
      return 'vi'
    case 'th':
      return 'th'
    case 'es':
      return 'es'
    case 'pt':
      return 'pt'
    case 'de':
      return 'de'
    case 'id':
      return 'id'
    case 'ar':
      return 'ar'
    case 'pl':
      return 'pl'
    case 'fa':
      return 'fa'
    case 'hi':
      return 'hi'
    case 'ru':
      return 'ru'
    default:
      return 'en'
  }
})

Vue.filter('zendeskLangSwitch', lang => {
  switch (lang) {
    case 'en_US':
      return 'en'
    case 'zh_CN':
      return 'zh-CN'
    case 'zh_TW':
      return 'zh-TW'
    case 'fr_FR':
      return 'fr'
    case 'ja':
      return 'ja'
    case 'ko':
      return 'ko'
    case 'vi':
      return 'vi'
    case 'th':
      return 'th'
    case 'es':
      return 'es'
    case 'pt':
      return 'pt'
    case 'de':
      return 'de'
    case 'id':
      return 'id'
    case 'ar':
      return 'ar'
    case 'pl':
      return 'pl'
    case 'fa':
      return 'fa'
    case 'ru':
      return 'ru'
    default:
      return 'en'
  }
})

Vue.filter('methods', method => {
  var key = method.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/\s]/g, '').toLowerCase()
  if (i18n.te('common.withdrawChannel.' + key) || i18n.te('common.withdrawChannel.' + key, 'en_US'))
    return i18n.t('common.withdrawChannel.' + key)
  return method
})

const currencyMap = {
  UST: 'USDT',
}

const currencyConvert = value => currencyMap[value?.toLocaleUpperCase()] || value

// 币种转换
Vue.filter('currencyConvert', currencyConvert)
